import { useParams } from 'react-router-dom';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { Breadcrumb } from '@sorare/core/src/components/breadcrumb';

import { Articles } from 'components/Articles';
import { Search } from 'components/Search';
import { SubmitRequest } from 'components/SubmitRequest';
import { useSection } from 'hooks/zendesk';

const Section = () => {
  const { sectionId } = useParams();
  const { category, section } = useSection(sectionId);

  const remappedSection = {
    ...section,
    name: section?.name || '',
    to: section?.html_url || '',
  };

  if (!section || !category) {
    return <LoadingIndicator fullHeight />;
  }

  return (
    <Vertical gap={3}>
      <Breadcrumb sections={[remappedSection]} />
      <Search />
      <SubmitRequest />
      <Articles section={section} />
    </Vertical>
  );
};

export default Section;
